
import {nav1hr, newProduct, resolveValidTime} from "../productUtils.js";
import * as utc from "../../util/utc.js";
import {gaiaPath} from "../gaia.js";
import * as sources from "../sources.js";
import {ø} from "../../util/objects.js";
import {tr} from "../../ux/translations.js";
import {scalarProduct} from "../scalarProduct.js";
import {createUnitDescriptors} from "../../util/units.js";
import {createUVIPalette} from "../../palette/uvi.js";
import {clamp} from "../../util/math.js";

let palettes = {};

function cpcuviPath(attr, alignment) {
    const validTime = resolveValidTime(attr.time_cursor, alignment);
    const isCurrent = attr.time_cursor === "current";
    const dir = isCurrent ? "current" : utc.print(validTime, "{YYYY}/{MM}/{DD}");
    const stamp = isCurrent ? "current" : utc.print(validTime, "{hh}{mm}");
    const file = `${stamp}-cpcuvi.epak`;
    return gaiaPath("data/cpcuvi", dir, file);
}

const label = tr`UV Index`;
const category = [
    tr`low`,        //  0
    tr`low`,        //  1
    tr`low`,        //  2
    tr`moderate`,   //  3
    tr`moderate`,   //  4
    tr`moderate`,   //  5
    tr`high`,       //  6
    tr`high`,       //  7
    tr`very high`,  //  8
    tr`very high`,  //  9
    tr`very high`,  // 10
    tr`extreme`,    // 11
];

function format(v) {
    const x = Math.round(v * 40);  // convert W/m^2 to UV Index
    const c = category[clamp(x, 0, 11)];
    const formattedVal = `${x} (${c})`;
    const fullText = `${formattedVal} ${label}`;
    return {formattedVal, fullText, scalarHTML: formattedVal};
}

export function createCPCUVILayer(attr) {
    const base = ø(newProduct(), nav1hr(attr.time_cursor));
    return ø(base, {
        sourceHTML: sources.cpc,
        type: "uv_index",
        descriptionHTML: {
            name: tr`Ultraviolet Index and Erythemal Dose Rate`,
            qualifier: ` @ ${tr`Surface`}`,
        },
        paths: [cpcuviPath(attr, base.alignment())],
        builder: file => scalarProduct(file, /Ultra_Violet_Index_surface/, {hasMissing: false}),
        unitDescriptors: createUnitDescriptors({
            "UV Index": {html: label, format},
            "mW/m^2":   {convert: x => x * 1000, precision: 0},
        }),
        alpha: {single: 210, animated: 160},
        scale: palettes.uv ??= createUVIPalette(),
    });
}
